// src/pages/patrimoines/AjouterPatrimoine.jsx
import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../../layouts/Header';
import Footer from '../../layouts/Footer';
import { ROLES } from '../../data/Menu';
import { COLORS } from '../../constants/colors';

// ===== STYLES =====
const styles = `
  .dashboard-styled {
    background: #f4f6f9;
    min-height: 100vh;
  }

  /* En-tête moderne */
  .header-modern {
    background: white;
    padding: 1.2rem 1.8rem;
    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
    border-left: 4px solid ${COLORS.secondary};
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .header-left {
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  .header-icon-wrapper {
    width: 48px;
    height: 48px;
    background: ${COLORS.primary};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    color: white;
    font-size: 1.4rem;
  }

  .gradient-text {
    color: #1e293b;
    font-size: 1.3rem;
    font-weight: 700;
    margin: 0;
  }

  .badge-modern {
    background: #f1f4f9;
    color: #475569;
    padding: 0.3rem 0.8rem;
    border-radius: 4px;
    font-size: 0.75rem;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
  .badge-modern i {
    color: ${COLORS.secondary};
  }

  .btn-modern-outline {
    border: 1px solid #d1d5db;
    background: white;
    padding: 0.4rem 1.2rem;
    border-radius: 4px;
    font-size: 0.85rem;
    font-weight: 500;
    color: #4b5563;
    transition: all 0.2s;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
  .btn-modern-outline:hover {
    border-color: ${COLORS.secondary};
    color: ${COLORS.secondary};
    background: #fafafa;
  }

  .btn-modern-primary {
    background: ${COLORS.primary};
    border: none;
    padding: 0.4rem 1.2rem;
    border-radius: 4px;
    font-size: 0.85rem;
    font-weight: 500;
    color: white;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: all 0.2s;
  }
  .btn-modern-primary:hover {
    background: ${COLORS.primaryDark};
    box-shadow: 0 4px 10px rgba(41,90,167,0.3);
  }

  .btn-modern-success {
    background: ${COLORS.success};
    border: none;
    padding: 0.4rem 1.2rem;
    border-radius: 4px;
    font-size: 0.85rem;
    font-weight: 500;
    color: white;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: all 0.2s;
  }
  .btn-modern-success:hover {
    background: #059669;
    box-shadow: 0 4px 10px rgba(16,185,129,0.3);
  }

  /* Card */
  .card-modern {
    border: none;
    border-radius: 4px;
    background: white;
    box-shadow: 0 2px 6px rgba(0,0,0,0.04);
    border-top: 3px solid transparent;
    transition: box-shadow 0.2s;
  }
  .card-modern:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.06);
  }
  .card-modern.border-primary {
    border-top-color: ${COLORS.primary};
  }

  .card-header-modern {
    background: transparent;
    border-bottom: 1px solid #e9edf2;
    padding: 0.8rem 1.2rem;
    font-weight: 600;
    color: #1e293b;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  .card-header-modern i {
    color: ${COLORS.secondary};
  }

  .card-body-modern {
    padding: 1.5rem;
  }

  /* Form */
  .form-label-modern {
    font-size: 0.7rem;
    font-weight: 600;
    color: #475569;
    margin-bottom: 0.2rem;
  }
  .form-label-modern .required {
    color: ${COLORS.danger};
    margin-left: 2px;
  }

  .form-control-modern, .form-select-modern {
    border: 1px solid #e2e8f0;
    border-radius: 4px;
    padding: 0.4rem 0.7rem;
    font-size: 0.85rem;
    transition: all 0.2s ease;
    background: white;
  }
  .form-control-modern:focus, .form-select-modern:focus {
    border-color: ${COLORS.primary};
    box-shadow: 0 0 0 3px rgba(41,90,167,0.08);
  }
  .form-control-modern.is-invalid, .form-select-modern.is-invalid {
    border-color: ${COLORS.danger};
  }
  .form-control-modern.is-invalid:focus, .form-select-modern.is-invalid:focus {
    box-shadow: 0 0 0 3px rgba(239,68,68,0.08);
  }

  .form-text-modern {
    font-size: 0.7rem;
    color: #94a3b8;
    margin-top: 0.2rem;
  }

  .input-icon-wrapper {
    position: relative;
  }
  .input-icon {
    position: absolute;
    left: 0.6rem;
    top: 50%;
    transform: translateY(-50%);
    color: #94a3b8;
    font-size: 1rem;
    z-index: 2;
  }
  .form-control-modern.with-icon,
  .form-select-modern.with-icon {
    padding-left: 2.2rem;
  }

  /* Notifications */
  .toast-notification {
    padding: 0.8rem 1rem;
    border: none;
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 1.5rem;
    animation: slideDown 0.3s ease-out;
    border-radius: 4px;
  }
  .toast-notification-success {
    background: #f0fdf4;
    border-left: 3px solid ${COLORS.success};
  }
  .toast-notification-error {
    background: #fef2f2;
    border-left: 3px solid ${COLORS.danger};
  }
  .toast-icon {
    width: 28px;
    height: 28px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-size: 1rem;
  }
  .toast-icon-success {
    background: rgba(16,185,129,0.15);
    color: ${COLORS.success};
  }
  .toast-icon-error {
    background: rgba(239,68,68,0.15);
    color: ${COLORS.danger};
  }
  .toast-content {
    flex: 1;
  }
  .toast-title {
    font-size: 0.8rem;
    font-weight: 600;
    margin-bottom: 1px;
  }
  .toast-message {
    font-size: 0.75rem;
    color: #64748b;
    margin: 0;
  }
  .toast-close {
    background: none;
    border: none;
    color: #94a3b8;
    cursor: pointer;
    padding: 2px;
    font-size: 1rem;
  }

  /* Loading */
  .loading-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 60vh;
  }
  .loading-ring-wrapper {
    position: relative;
    width: 70px;
    height: 70px;
  }
  .loading-ring {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 3px solid #e9edf2;
    border-top-color: ${COLORS.primary};
    animation: spin 0.8s linear infinite;
  }
  .loading-ring-inner {
    position: absolute;
    top: 8px;
    left: 8px;
    right: 8px;
    bottom: 8px;
    border-radius: 50%;
    border: 2px solid #e9edf2;
    border-bottom-color: ${COLORS.secondary};
    animation: spin 0.6s linear infinite reverse;
  }
  @keyframes spin { to { transform: rotate(360deg); } }

  /* Animations */
  @keyframes slideDown {
    from { opacity: 0; transform: translateY(-8px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(6px); }
    to { opacity: 1; transform: translateY(0); }
  }
  .fade-in {
    animation: fadeIn 0.3s ease-out;
  }

  @media (max-width: 768px) {
    .header-modern {
      flex-direction: column;
      align-items: stretch;
      gap: 0.8rem;
      padding: 1rem;
    }
    .header-left {
      flex-wrap: wrap;
    }
    .card-body-modern {
      padding: 1rem;
    }
  }
`;

export default function AjouterPatrimoine() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [temples, setTemples] = useState([]);
  const [permissions, setPermissions] = useState({
    canAdd: false,
    canEdit: false
  });

  const [formData, setFormData] = useState({
    intitule: '',
    quantite: '',
    date_at: new Date().toISOString().split('T')[0],
    description: '',
    matri_eglise: ''
  });

  const [validationErrors, setValidationErrors] = useState({});

  // Vérification des permissions
  const hasPermission = (action) => {
    try {
      const userStr = localStorage.getItem('user');
      if (!userStr) return false;
      const user = JSON.parse(userStr);
      const userRole = user.role || user.type_utilisateur;
      if (userRole === ROLES.SUPER_ADMIN) return true;

      const permissionsMap = {
        'add_patrimoine': [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.PASTEUR, ROLES.ANCIEN, ROLES.DIACRE, ROLES.DIACONESSE],
        'edit_patrimoine': [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.PASTEUR, ROLES.ANCIEN]
      };
      return permissionsMap[action]?.includes(userRole) || false;
    } catch (e) { return false; }
  };

  useEffect(() => {
    setPermissions({
      canAdd: hasPermission('add_patrimoine'),
      canEdit: hasPermission('edit_patrimoine')
    });
  }, []);

  // Chargement initial
  useEffect(() => {
    const fetchInitialData = async () => {
      setLoading(true);
      try {
        const userStr = localStorage.getItem('user');
        if (!userStr) {
          navigate('/pages/signin2');
          return;
        }
        const user = JSON.parse(userStr);
        const userId = user.id || user.id_utilisateur;

        // Charger les temples
        const templesRes = await fetch(`https://josephsbusiness.com/api/eglises.php?user_id=${userId}&parent=filiale&limit=1000`);
        const templesData = await templesRes.json();
        if (templesData.success) {
          setTemples(templesData.eglises || []);
        }

        // Si modification, charger les données
        if (id) {
          const patrimoineRes = await fetch(`https://josephsbusiness.com/api/patrimoines.php?user_id=${userId}&id=${id}`);
          const patrimoineData = await patrimoineRes.json();
          if (patrimoineData.success && patrimoineData.patrimoine) {
            const patrimoine = patrimoineData.patrimoine;
            setFormData({
              intitule: patrimoine.intitule || '',
              quantite: patrimoine.quantite,
              date_at: patrimoine.date_at,
              description: patrimoine.description || '',
              matri_eglise: patrimoine.matri_eglise || ''
            });
          }
        }
      } catch (err) {
        setError('Erreur lors du chargement des données: ' + err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchInitialData();
  }, [id, navigate]);

  const validateForm = () => {
    const errors = {};
    if (!formData.intitule.trim()) errors.intitule = "L'intitulé est requis";
    if (!formData.quantite) errors.quantite = 'La quantité est requise';
    else if (isNaN(formData.quantite) || parseInt(formData.quantite) <= 0) {
      errors.quantite = 'La quantité doit être un nombre positif';
    }
    if (!formData.date_at) errors.date_at = 'La date est requise';
    if (!formData.matri_eglise) errors.matri_eglise = 'Le temple est requis';

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (validationErrors[name]) {
      setValidationErrors(prev => ({ ...prev, [name]: null }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setSaving(true);
    setError(null);

    try {
      const userStr = localStorage.getItem('user');
      const user = JSON.parse(userStr);
      const userId = user.id || user.id_utilisateur;

      const url = id
        ? `https://josephsbusiness.com/api/patrimoines.php?user_id=${userId}&id=${id}`
        : `https://josephsbusiness.com/api/patrimoines.php?user_id=${userId}`;

      const method = id ? 'PUT' : 'POST';

      const dataToSend = {
        intitule: formData.intitule,
        quantite: parseInt(formData.quantite),
        date_at: formData.date_at,
        description: formData.description,
        matri_eglise: formData.matri_eglise
      };
      if (id) dataToSend.id = parseInt(id);

      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(dataToSend)
      });

      const result = await response.json();

      if (result.success) {
        setSuccess(true);
        setTimeout(() => {
          window.location.href = '/patrimoines/liste?reload=' + Date.now();
        }, 2000);
      } else {
        setError(result.message || 'Erreur lors de l\'enregistrement');
      }
    } catch (err) {
      console.error('Erreur:', err);
      setError('Erreur: ' + err.message);
    } finally {
      setSaving(false);
    }
  };

   if (loading) {
     return (
         <>
             <Header />
             <div className="main main-app p-3 p-lg-4 dashboard-styled">
                 <div className="loading-wrapper">
                     <div className="text-center">
                         {/* Logo ou icône animé */}
                         {/* <div className="loading-icon-wrapper mb-4">
                             <div className="loading-icon-pulse">
                                 <i className="ri-building-line" style={{ fontSize: '3.5rem', color: COLORS.primary }}></i>
                             </div>
                         </div> */}
 
                         {/* Anneau de chargement amélioré */}
                         <div className="loading-ring-wrapper mb-4">
                             <div className="loading-ring"></div>
                             <div className="loading-ring-inner"></div>
                             <div className="loading-ring-dot"></div>
                         </div>
 
                         {/* Titre avec effet de gradient */}
                         <h5 className="fw-bold loading-title" style={{ 
                             color: COLORS.primary,
                             background: `linear-gradient(135deg, ${COLORS.primary}, ${COLORS.secondary})`,
                             WebkitBackgroundClip: 'text',
                             WebkitTextFillColor: 'transparent',
                             backgroundClip: 'text',
                             fontSize: '1.4rem'
                         }}>
                             Chargement en cours
                         </h5>
 
                         {/* Message avec animation de points */}
                         <p className="text-muted small loading-message">
                             Récupération des données
                             <span className="loading-dots">
                                 <span>.</span><span>.</span><span>.</span>
                             </span>
                         </p>
 
                         {/* Barre de progression stylisée */}
                         <div className="loading-progress-wrapper mt-4">
                             <div className="loading-progress-track">
                                 <div className="loading-progress-bar"></div>
                             </div>
                         </div>
                     </div>
                 </div>
             </div>
             <Footer />
 
             {/* Styles intégrés pour le loading */}
             <style>{`
                 .loading-wrapper {
                     display: flex;
                     justify-content: center;
                     align-items: center;
                     min-height: 60vh;
                 }
 
                 /* Icône animée */
                 .loading-icon-wrapper {
                     position: relative;
                     width: 80px;
                     height: 80px;
                     margin: 0 auto;
                 }
                 .loading-icon-pulse {
                     animation: iconPulse 1.8s ease-in-out infinite;
                 }
                 @keyframes iconPulse {
                     0%, 100% { transform: scale(1); opacity: 1; }
                     50% { transform: scale(1.1); opacity: 0.6; }
                 }
 
                 /* Anneaux de chargement */
                 .loading-ring-wrapper {
                     position: relative;
                     width: 70px;
                     height: 70px;
                     margin: 0 auto;
                 }
                 .loading-ring {
                     position: absolute;
                     width: 100%;
                     height: 100%;
                     border-radius: 50%;
                     border: 3px solid #e9edf2;
                     border-top-color: ${COLORS.primary};
                     animation: spin 1s cubic-bezier(0.6, 0.2, 0.4, 0.8) infinite;
                 }
                 .loading-ring-inner {
                     position: absolute;
                     top: 8px;
                     left: 8px;
                     right: 8px;
                     bottom: 8px;
                     border-radius: 50%;
                     border: 2px solid #e9edf2;
                     border-bottom-color: ${COLORS.secondary};
                     animation: spin 0.7s cubic-bezier(0.4, 0.0, 0.2, 1) infinite reverse;
                 }
                 .loading-ring-dot {
                     position: absolute;
                     top: 50%;
                     left: 50%;
                     transform: translate(-50%, -50%);
                     width: 12px;
                     height: 12px;
                     border-radius: 50%;
                     background: ${COLORS.primary};
                     box-shadow: 0 0 20px ${COLORS.primary}40;
                     animation: dotPulse 1.2s ease-in-out infinite;
                 }
                 @keyframes spin {
                     to { transform: rotate(360deg); }
                 }
                 @keyframes dotPulse {
                     0%, 100% { transform: translate(-50%, -50%) scale(0.8); opacity: 0.6; }
                     50% { transform: translate(-50%, -50%) scale(1.2); opacity: 1; }
                 }
 
                 /* Titre avec dégradé (déjà géré en inline) */
                 .loading-title {
                     margin-bottom: 0.25rem;
                 }
 
                 /* Message avec points animés */
                 .loading-message {
                     font-size: 0.9rem;
                     color: #94a3b8;
                 }
                 .loading-dots span {
                     animation: dots 1.4s infinite;
                     opacity: 0;
                 }
                 .loading-dots span:nth-child(1) { animation-delay: 0s; }
                 .loading-dots span:nth-child(2) { animation-delay: 0.2s; }
                 .loading-dots span:nth-child(3) { animation-delay: 0.4s; }
                 @keyframes dots {
                     0% { opacity: 0; }
                     50% { opacity: 1; }
                     100% { opacity: 0; }
                 }
 
                 /* Barre de progression */
                 .loading-progress-wrapper {
                     max-width: 250px;
                     margin: 0 auto;
                 }
                 .loading-progress-track {
                     width: 100%;
                     height: 4px;
                     background: #e9edf2;
                     border-radius: 4px;
                     overflow: hidden;
                 }
                 .loading-progress-bar {
                     width: 0%;
                     height: 100%;
                     background: linear-gradient(90deg, ${COLORS.primary}, ${COLORS.secondary}, ${COLORS.primary});
                     background-size: 200% 100%;
                     border-radius: 4px;
                     animation: progress 2s ease-in-out infinite;
                 }
                 @keyframes progress {
                     0% { width: 0%; background-position: 200% 0; }
                     50% { width: 70%; background-position: 100% 0; }
                     100% { width: 100%; background-position: 0% 0; }
                 }
             `}</style>
         </>
     );
 }

  return (
    <>
      <style>{styles}</style>
      <Header />
      <div className="main main-app p-3 p-lg-4 dashboard-styled">
        <div className="container-fluid px-0">

          {/* ===== EN‑TÊTE MODERNE ===== */}
          <div className="header-modern mb-4 fade-in">
            <div className="header-left">
              <div className="header-icon-wrapper">
                <i className={id ? "ri-edit-line" : "ri-add-line"}></i>
              </div>
              <div>
                <h5 className="gradient-text">
                  {id ? 'Modifier le patrimoine' : 'Nouveau patrimoine'}
                </h5>
                <div className="d-flex flex-wrap gap-2">
                  <span className="badge-modern">
                    <i className="ri-information-line"></i>
                    {id ? 'Modification' : 'Création'}
                  </span>
                  <span className="badge-modern">
                    <i className="ri-calendar-line"></i>
                    {new Date().toLocaleDateString('fr-FR')}
                  </span>
                </div>
              </div>
            </div>
            <div className="d-flex gap-2">
              <Button size="sm" className="btn-modern-outline" onClick={() => navigate('/patrimoines/liste')}>
                <i className="ri-arrow-left-line"></i> Retour
              </Button>
            </div>
          </div>

          {/* ===== NOTIFICATIONS ===== */}
          {error && (
            <div className="toast-notification toast-notification-error mb-4">
              <div className="toast-icon toast-icon-error">
                <i className="ri-error-warning-line"></i>
              </div>
              <div className="toast-content">
                <div className="toast-title" style={{ color: COLORS.danger }}>Erreur</div>
                <p className="toast-message">{error}</p>
              </div>
              <button className="toast-close" onClick={() => setError(null)}>
                <i className="ri-close-line"></i>
              </button>
            </div>
          )}

          {success && (
            <div className="toast-notification toast-notification-success mb-4">
              <div className="toast-icon toast-icon-success">
                <i className="ri-checkbox-circle-line"></i>
              </div>
              <div className="toast-content">
                <div className="toast-title" style={{ color: COLORS.success }}>Succès</div>
                <p className="toast-message">Patrimoine enregistré avec succès. Redirection...</p>
              </div>
              <button className="toast-close" onClick={() => setSuccess(false)}>
                <i className="ri-close-line"></i>
              </button>
            </div>
          )}

          {/* ===== CARD PRINCIPALE ===== */}
          <Row className="justify-content-center">
            <Col md={8}>
              <Card className="card-modern border-primary">
                <Card.Header className="card-header-modern">
                  <i className="ri-information-line"></i> Informations du patrimoine
                </Card.Header>
                <Card.Body className="card-body-modern">
                  <Form onSubmit={handleSubmit}>
                    <Row className="g-3">
                      {/* Intitulé */}
                      <Col md={12}>
                        <Form.Group controlId="intitule">
                          <Form.Label className="form-label-modern">
                            Intitulé <span className="required">*</span>
                          </Form.Label>
                          <div className="input-icon-wrapper">
                            <i className="ri-price-tag-3-line input-icon"></i>
                            <Form.Control
                              type="text"
                              name="intitule"
                              value={formData.intitule}
                              onChange={handleInputChange}
                              isInvalid={!!validationErrors.intitule}
                              className="form-control-modern with-icon"
                              placeholder="Ex: Chaises, Tables, Projecteur..."
                            />
                            {validationErrors.intitule && (
                              <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                                {validationErrors.intitule}
                              </Form.Control.Feedback>
                            )}
                          </div>
                        </Form.Group>
                      </Col>

                      {/* Quantité */}
                      <Col md={6}>
                        <Form.Group controlId="quantite">
                          <Form.Label className="form-label-modern">
                            Quantité <span className="required">*</span>
                          </Form.Label>
                          <div className="input-icon-wrapper">
                            <i className="ri-stack-line input-icon"></i>
                            <Form.Control
                              type="number"
                              name="quantite"
                              value={formData.quantite}
                              onChange={handleInputChange}
                              isInvalid={!!validationErrors.quantite}
                              min="1"
                              step="1"
                              className="form-control-modern with-icon"
                              placeholder="Ex: 50"
                            />
                            {validationErrors.quantite && (
                              <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                                {validationErrors.quantite}
                              </Form.Control.Feedback>
                            )}
                          </div>
                        </Form.Group>
                      </Col>

                      {/* Date */}
                      <Col md={6}>
                        <Form.Group controlId="date_at">
                          <Form.Label className="form-label-modern">
                            Date d'acquisition <span className="required">*</span>
                          </Form.Label>
                          <div className="input-icon-wrapper">
                            <i className="ri-calendar-line input-icon"></i>
                            <Form.Control
                              type="date"
                              name="date_at"
                              value={formData.date_at}
                              onChange={handleInputChange}
                              isInvalid={!!validationErrors.date_at}
                              className="form-control-modern with-icon"
                            />
                            {validationErrors.date_at && (
                              <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                                {validationErrors.date_at}
                              </Form.Control.Feedback>
                            )}
                          </div>
                        </Form.Group>
                      </Col>

                      {/* Temple */}
                      <Col md={12}>
                        <Form.Group controlId="matri_eglise">
                          <Form.Label className="form-label-modern">
                            Temple <span className="required">*</span>
                          </Form.Label>
                          <div className="input-icon-wrapper">
                            <i className="ri-building-2-line input-icon"></i>
                            <Form.Select
                              name="matri_eglise"
                              value={formData.matri_eglise}
                              onChange={handleInputChange}
                              isInvalid={!!validationErrors.matri_eglise}
                              className="form-select-modern with-icon"
                            >
                              <option value="">Sélectionner un temple</option>
                              {temples.map(temple => (
                                <option key={temple.matricule} value={temple.matricule}>
                                  {temple.nom} - {temple.ville}
                                </option>
                              ))}
                            </Form.Select>
                            {validationErrors.matri_eglise && (
                              <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                                {validationErrors.matri_eglise}
                              </Form.Control.Feedback>
                            )}
                          </div>
                        </Form.Group>
                      </Col>

                      {/* Description */}
                      <Col md={12}>
                        <Form.Group controlId="description">
                          <Form.Label className="form-label-modern">
                            Description
                          </Form.Label>
                          <div className="input-icon-wrapper">
                            <i className="ri-file-text-line input-icon"></i>
                            <Form.Control
                              as="textarea"
                              rows={3}
                              name="description"
                              value={formData.description}
                              onChange={handleInputChange}
                              className="form-control-modern with-icon"
                              placeholder="Description détaillée du bien..."
                            />
                          </div>
                          <Form.Text className="form-text-modern">
                            Optionnel - Ajoutez des détails sur l'état, la marque, etc.
                          </Form.Text>
                        </Form.Group>
                      </Col>

                      {/* Boutons */}
                      <Col md={12} className="mt-3">
                        <div className="d-flex justify-content-end gap-3">
                          <Button
                            variant="light"
                            onClick={() => navigate('/patrimoines/liste')}
                            disabled={saving}
                            className="btn-modern-outline"
                          >
                            <i className="ri-close-line me-1"></i> Annuler
                          </Button>
                          <Button
                            type="submit"
                            disabled={saving}
                            className="btn-modern-primary"
                            style={{ background: `linear-gradient(135deg, #8b5cf6, #6d28d9)` }}
                          >
                            {saving ? (
                              <><Spinner size="sm" className="me-1" /> {id ? 'Modification...' : 'Enregistrement...'}</>
                            ) : (
                              <><i className="ri-check-line me-1"></i> {id ? 'Modifier' : 'Ajouter'}</>
                            )}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Footer />
        </div>
      </div>
    </>
  );
}